export default __webpack_public_path__ + "static/media/CapaResumo.5b42acd4.5b42acd4.webp";